import { IsNotEmpty, IsUUID } from 'class-validator';

export class TradeRequestEditDTO {

    @IsNotEmpty()
    @IsUUID()
    eventId: string;

}
